exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-progress-spinner{\r\n    height: 100% !important;\r\n    width: 100% !important;\r\n    margin: auto;\r\n    display: block;\r\n}\r\n.mat-progress-spinner svg{\r\n    margin: auto;\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/with-loader/with-loader.component.css
// module id = ../../../../../src/app/directive/with-loader/with-loader.component.css
// module chunks = main